import { render, staticRenderFns } from "./HrDashboardData.vue?vue&type=template&id=50fac5ae&scoped=true"
import script from "./HrDashboardData.vue?vue&type=script&lang=js"
export * from "./HrDashboardData.vue?vue&type=script&lang=js"
import style0 from "./HrDashboardData.vue?vue&type=style&index=0&id=50fac5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fac5ae",
  null
  
)

export default component.exports